(function() {
  function initBenefitsAccordion(section) {
    if (!section) return;

    const accordionHeaders = section.querySelectorAll('.ctr-benefits-accordion__header');

    accordionHeaders.forEach((header) => {
      header.addEventListener('click', function() {
        const item = this.closest('.ctr-benefits-accordion__item');
        const isActive = item.classList.contains('ctr-benefits-accordion__item--active');
        
        // Close all items
        section.querySelectorAll('.ctr-benefits-accordion__item').forEach((otherItem) => {
          otherItem.classList.remove('ctr-benefits-accordion__item--active');
          otherItem.querySelector('.ctr-benefits-accordion__header').setAttribute('aria-expanded', 'false');
        });

        // Toggle current item
        if (!isActive) {
          item.classList.add('ctr-benefits-accordion__item--active');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // Initialize all Benefits Accordion sections on page load
  document.querySelectorAll('.ctr-benefits-accordion').forEach(initBenefitsAccordion);

  // Support for Shopify section rendering (theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target.querySelector('.ctr-benefits-accordion');
    if (section) initBenefitsAccordion(section);
  });
})();
